import { useElementHover } from '@vueuse/core'
import { watch } from 'vue'

export default {
  created(el, binding) {
    const hovered = useElementHover(el, {})

    watch(hovered, hovered => {
      el.classList[hovered ? 'add' : 'remove']('show')
      el.querySelector('.dropdown-menu').classList[hovered ? 'add' : 'remove']('show')
    })
  },
}
